import { render, staticRenderFns } from "./templateDetail.vue?vue&type=template&id=b9e4927e&"
import script from "./templateDetail.vue?vue&type=script&lang=js&"
export * from "./templateDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports